import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowMidLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M39.75 22.5H11.871l10.101-10.1-2.122-2.121L6.128 24 19.85 37.721l2.122-2.121-10.101-10.1H39.75z" }) }) })
});
export default SvgArrowMidLeft;
